export default __webpack_public_path__ + "09f8d113a0a8556d926bd04451b42a81.jpg";